@if (this.isLoading) {
  <div class="absolute loading text-success w-24 h-24">
    <span class="loading loading-ring"></span>
  </div>
} @else {
  <div class="h-pb-container">
    @if (this.transport) {
      <div class="absolute-transport-info">
        <div>{{ this.transport.loadingPlace }}, {{ this.transport.loadingUn2 }}
          - {{ this.transport.deliveryPlace }}, {{ this.transport.deliveryUn2 }}
        </div>

        @if (this.transport.packages && this.transport.packages.length > 0) {
          <div>
            @for (pack of this.transport.packages; let last = $last; track pack.short) {
              <span>{{ pack.amount }} {{ pack.name }}<span class="mx-2"> @if (!last) {|}</span></span>
            }
          </div>
        }

        <div>Total volume: {{ this.transport.totalVolume }}M&#179;
          Total weight: {{ this.transport.totalWeight }}KG
        </div>
      </div>
      <div class="wrapper">
        <div class="buttons">
          @for (event of transportEvents; track event.id) {
            <div class="text-center flex items-center flex-col">
              <div class="mb-2 p-3 text-center btn-circle transition-all duration-1000 ease-in-out"
                   [ngClass]="this.getEventClass(event)">
                <i [class]="event.icon" class="text-white"></i>
              </div>
              <div class="absolute mt-14 w-48">
                <div>{{ event.name }}</div>
                @if (event.startDate) { <div class="gray-500">{{ event.startDate | date: "dd/MM/YYYY" }}</div> }
                @if (event.endDate) { <div>Until {{ event.endDate | date: "dd/MM/YYYY" }}</div> }
                @if (event.startTime && event.endTime) { <div>Between {{ event.startTime }} and {{ event.endTime }}</div> }
                @if (event.startTime && !event.endTime) { <div>At {{ event.startTime }}</div> }
                @if (event.expected) { <div class="gray-400">Expected</div> }
              </div>
            </div>
          }
        </div>
        <div class="bar animate" [ngStyle]="this.styles()"></div>
      </div>
    }
    <div class="absolute-action-buttons">
      <button class="btn btn-primary" (click)="this.goBack()">Search again</button>
    </div>
  </div>
  @if (!this.transport) {
    <h1 class="bar text-center text-2xl md:text-4xl font-bold">No transport found!</h1>
  }

  <!--  Vertical progressbar-->
  <div class="v-pb-container">
    <div class="content-between flex flex-col h-full" style="align-items: center; justify-content: space-evenly;">
      <div class="text-center">
        @if (this.transport) {
          <div>{{ this.transport.loadingPlace }}
            - {{ this.transport.deliveryPlace }}</div>
        }
        @if (this.transport && this.transport.packages && this.transport.packages.length > 0) {
          <div>
            @for (pack of this.transport.packages; let last = $last; track pack.short) {
              <span class="tooltip" [attr.data-tip]="pack.name">
                <span style="border-bottom: dashed darkgrey 1px">
                  {{ pack.amount }} {{ pack.short }} <i class="fa-solid text-primary fa-circle-question"></i>
                </span>
                @if (!last) {
                  <span class="mx-3">|</span>
                }
              </span>
            }
          </div>
        }
        @if (this.transport) {
          <div>Total volume: {{ this.transport.totalVolume }}M&#179;
            Total weight: {{ this.transport.totalWeight }}kg</div>
        }
      </div>

      @for (event of this.transportEvents; let i = $index; track event.id) {
        <div class="flex align-middle items-center">
          <div [ngClass]="{ 'bg-success': step - 1 > i, 'bg-info': step - 1 === i, 'bg-neutral-content': step - 1 < i }"
               class="p-3 text-center btn-circle z-10">
            <i [class]="event.icon" class="text-white"></i>
          </div>
          <div class="text-center w-48 text">
            <div>{{ event.name }}</div>
            @if (event.startDate) { <div class="gray-500">{{ event.startDate | date: "dd/MM/YYYY" }}</div> }
            @if (event.endDate) { <div>Until {{ event.endDate | date: "dd/MM/YYYY" }}</div> }
            @if (event.startTime && event.endTime) { <div>Between {{ event.startTime }} and {{ event.endTime }}</div> }
            @if (event.startTime && !event.endTime) { <div>At {{ event.startTime }}</div> }
            @if (event.expected) { <div class="gray-400">Expected</div> }
          </div>
        </div>
      }

      <button class="btn btn-primary" (click)="this.goBack()">Search again</button>
    </div>
  </div>
}
